export default "/assets/webpack-assets/voucher-riparide.3db5f76698fbbd0f7e9637b4108cd671.jpg";